<template>

    <div>
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold  text-white">Account Info</h1>
                            <h4 class="font-weight-light  text-white">MANAGE ADDRESS AND USERS</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Boxes-->
        <div class="boxes-hero">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col">
                                        Account Address
                                    </div>
                                    <b-link
                                            id="edit-address-link"
                                            @click="toggle_address_modal">
                                        <span style="margin-right:20px" class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                                    </b-link>
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <div class="row py-2">
                                    <div class="col-md-12">
                                        <b-table :items="address" :fields="address_fields" show-empty stacked>
                                            <template v-slot:cell(state)="item">
                                                {{
                                                stateOptions.find(({ value }) => value === item.value)
                                                ?   stateOptions.find(({ value }) => value === item.value).text
                                                :   null
                                                }}
                                            </template>
                                        </b-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue rounded-top p-3">
                                <div class="row">
                                    <div class="col">
                                        Users
                                    </div>
                                    <div class="col text-right">
                                        <button class="btn btn-light btn-rounded" data-toggle="modal" data-target="#newDevice">
                                            <b-link style="color: white" @click="toggle_create_user_modal"> + New User</b-link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <div class="row py-2">
                                    <div class="col-md-12">
                                        <b-table :items="users" :fields="user_fields" striped show-empty>
                                            <template v-slot:cell(action)="item">
                                                <div style="width:100px">
                                                    <b-link @click="select_user(item.item)">
                                                        <span style="float: left;" class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                                                    </b-link>
                                                    <b-link @click="request_delete(item.item)">
                                                        <span style="float: right;" class="icon-blue mx-1"><img src="/icons/icon-delete.png" height="20"></span>
                                                    </b-link>
                                                </div>
                                            </template>
                                        </b-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <div class="boxes mb-4">
        <div class="container">
          <div class="row equal">
            <div class="col-md-12 my-2">
              <div class="box shadow-lg bg-white rounded">
                <div class="box-header bg-light-blue p-3">
                      Account Agreements
                </div>
                <div class="box-body p-3">
                  <div class="row py-2">
                    <div class="col-md-12">
                    <div style="padding: 1rem 1rem; text-align: left;">
                      <div>
                        <div class="text-center">
                          <h1>Service Agreement</h1>
                        </div>
                        <br/>
                        <div class="scroll">
                          <br/>
                          This Service Agreement (the “Agreement”) states the terms and conditions that govern the contractual agreement between KonaMetrix Inc™, having its principal mailing address of 4055 Sequoia St, Unit 1, San Diego, CA 92109 (“KM”), and Customer, as indicated in the on-boarding process on the KM Customer Portal, (“Customer”) who agrees to be bound by this Agreement.
                          <br/><br/>
                          WHEREAS, KM is engaged in the business of offering remote leak detection monitoring, alert notifications and reporting services for your property; and
                          <br/><br/>
                          WHEREAS, the Customer desires to retain the services of KM provide detection services and reports according to the terms and conditions herein; and
                          <br/><br/>
                          NOW, THEREFORE, in consideration of the mutual covenants and promises made by the parties hereto, KM and Customer (individually, each a “Party” and collectively, the “Parties”) covenant and agree as follows:
                          <br/><br/>

                          <h3>TERM & WARRANTY</h3>
                          KM shall perform the Services described herein for a period of time described and as selected by Customer on the Customer Portal.  This Agreement shall automatically renew for the same term period as the original contract, unless otherwise agreed to in writing no less than sixty (60) days of the then termination date. Either Party may terminate this Agreement for any reason by giving sixty (60) Days written notice to the other Party. Any termination prior to the completion of the full term could result in the loss of any discounts applied. Customer hereby agrees to a final charge for any unearned discount. Upon the termination date, all customer access will be revoked. Pricing may change at renewal to the then current price as advertised.
                          <br/><br/>
                          The KM products are warrantied for one (1) year from the date of installation against manufacturing defects. If a product malfunctions, KM will immediately ship a replacement device at no cost to the Customer. A prepaid return label will be supplied for the return of the defective product. Should the defective product not be returned within thirty (30) days or it is determined that the device failed for any reason other than manufacturing defects, Customer agrees to be charged for the full price of the replacement unit, including shipping.
                          <br/><br/>
                          <h3>SERVICES</h3>
                          KM agrees that it shall perform the services described, and in accordance with the Service Plan selected by Customer.
                          <br/><br/>
                          <h3>PAYMENTS</h3>
                          In consideration for the Services, the Customer shall pay KM a rate as specified and selected by Customer in the Customer Portal. Each month of service is pre-paid consistent with wireless operator practice and policy throughout the world, unless an annual or multi-year plan is subscribed and paid in full. KM will automatically charge or debit Customer’s account as designated on the Customer Portal on a monthly, annual, or multi-year basis.
                          <br/><br/>
                          <h3>END USER LICENSE AGREEMENT</h3>
                          Customer shall agree to the general terms of the End User License Agreement (EULA) for KonaMetrix, Inc.  as designated in the Customer Portal
                          <br/><br/>
                          <h3>NO MODIFICATION UNLESS IN WRITING</h3>
                          No modification of this Agreement shall be valid unless in writing and agreed upon by both Parties. Modifications may be submitted by either Party via email or konametrix.com html contact page.
                          <br/><br/>
                          <h3>APPLICABLE LAW</h3>
                          This Services Agreement and the interpretation of its terms shall be governed by and construed in accordance with the laws of the State of California, subject to the exclusive jurisdiction of the federal and state courts located in San Diego County, California, USA.
                          <br/><br/>
                          BY ELECTRONICALLY CLICKING “YES”, Customer is acknowledging that they are duly authorized to accept the terms of this Service Agreement and bind both Parties accordingly as of this date.
                          <br/><br/>
                        </div>
                        <br/>
                        <table width="100%" style="font-weight: bold">
                          <tr>
                            <td>Customer is authorized to accept the terms of this Service Agreement and hereby authorizes KM to commence Services and Payment in accordance with the Service Plan selected by Customer.</td>
                          </tr>
                        </table>
                      </div>
                      <br/><br/>
                      <div>
                        <div class="text-center">
                          <h1>End User Product License Agreement</h1>
                        </div>
                        <br/>
                        <div class="scroll">
                          This license and user agreement (the "Agreement") is entered into between you, as a private person or a company ("Licensee") and KonaMetrix Inc, having its registered address at 4055 Sequoia St., Unit 1, San Diego California 92109. By installing, reading, copying or otherwise using all or any portion of the KonaMetrix Inc. products including software, hardware, documentation and future updates to this system, the Licensee agrees to be bound by the terms of the Agreement. The products include sensors and other networked devices for the purpose of environmental sensing and water use awareness.
                          <br/><br/>
                          <h3>Definitions</h3>
                          Documentation means the user guide, help information and/or other documentation provided by Licensor with the Software.
                          <br/><br/>
                          Licensee means the User, together with the business or other entity for which the Software is obtained.
                          <br/><br/>
                          Software means any computer program used by licensor under this Agreement.
                          <br/><br/>
                          Hardware means any devices. Sensors, electronics, batteries or wires or circuits, radios routers, repeaters and power supplies or installation materials.
                          <br/><br/>
                          Updates means, if applicable, any patch, update or new version of the Software or hardware delivered to Licensee pursuant to the Support Services or Over the Air update methods.
                          <br/><br/>
                          User means you, the individual who accepts this Agreement and your assigns if you give them permission to access your accounts.
                          <br/><br/>
                          Product is all hardware, software and installed components
                          <br/><br/>
                          The data generated by the hardware and software are results of proprietary sensory systems and algorithmic methods and are exclusive property of KonaMetrix Inc. Patents pending  copyright 2020
                          <br/><br/>
                          <h3>1.0 License and Lease</h3>
                          (1.1) License Grant. Licensor grants to you a nonexclusive, limited, non- transferable, royalty free license to install and use the Software and Hardware installed at a single property location or building structure.
                          <br/><br/>
                          (1.2) Documentation. You may make and use an unlimited number of copies of any documentation, provided that such copies shall be used only for personal purposes and are not to be republished or distributed (either in hard copy or electronic form) beyond your premises.
                          <br/><br/>
                          (1.3) Server Use. You may install one copy of the Software on your computer file server for the purpose of downloading and installing the Software onto other computers within your internal network up to the Permitted Number of computers in a commercial environment only.
                          <br/><br/>
                          (1.4) Software Transfer. This EULA and Software is not transferable to another end user, any assigned users of the licensor must first agree to all of the EULA terms.
                          <br/><br/>
                          (1.5) The hardware is sold or leased in accordance with the sale or lease price sheet
                          <br/><br/>
                          <h3>2.0 Restrictions</h3>
                          Licensee shall not:
                          <br/><br/>
                          (2.1) use any Confidential Information to create any software, hardware or documentation that is similar to any Software, hardware product or Documentation.
                          <br/><br/>
                          (2.2) dis-assemble, decompile, reverse engineer or otherwise try to discover any source code, circuit designs or underlying structures, ideas or algorithms of the Software (except and only to the extent these restrictions are expressly prohibited by applicable statutory law),
                          <br/><br/>
                          (2.3) encumber, lease, rent, loan, sublicense, transfer or distribute any Software or hardware,
                          <br/><br/>
                          (2.4) copy, adapt, merge, create derivative works of, translate, localize, port or otherwise modify any Software, hardware or Documentation,
                          <br/><br/>
                          (2.5) use the Software or hardware in an automated process without express written permission and license by KonaMetrix, Inc.
                          <br/><br/>
                          (2.6) use the Software or hardware, or allow the transfer, transmission, export or re-export of all or any part of the Software or any product thereof, in violation of any export control laws or regulations of the United States or any other relevant jurisdiction or
                          <br/><br/>
                          (2.7) permit any third party to engage in any of the foregoing proscribed acts. Licensee shall not use the Software or hardware for the benefit of any third party (e.g., time-share or service bureau arrangement) without Licensor's prior written consent, at its discretion.
                          <br/><br/>
                          <h3>3.0 Ownership</h3>
                          (3.1) KonaMetrix Inc. reserves all rights not expressly granted to you in this EULA. The Software, hardware and system designs are protected by copyright and other intellectual property laws and treaties. KonaMetrix Inc. or its suppliers own the title, copyright, and other intellectual property rights in the Software and the hardware product. The Software is licensed, not sold. KonaMetrix Inc. End User agrees that KonaMetrix Inc. is the sole and exclusive owner of all rights to product design, features and improvements. The Product is protected by United States copyright, Patent law and other laws, as well as international treaty provisions, and End User must treat the Product as any other copyrighted, patent pending and legally protected material. All rights in the Product not expressly granted herein are reserved by KonaMetrix. Inc. This includes all data rights. By signing below or using the product you agree that KonaMetrix Inc. owns all rights to this software, the manufacturing rights to the hardware product, design improvements and any and all data generated by same.
                          <br/><br/>
                          (3.2) KonaMetrix Inc. owns all data deposited into its server files from your inputs to the web portal apps, all sensor functions and measures.
                          <br/><br/>
                          <h3>4.0 Fees and Payment</h3>
                          (4.1) KonaMetrix Inc. reserves the right to charge fees for future use of or access to the Software, additional hardware, hardware upgrades or data displays, formats or delivery methods at its sole discretion. If KonaMetrix Inc. decides to charge for the Software, hardware, data display or access to such data, software, hardware and displays or reports of data, such charges will be disclosed to you.
                          <br/><br/>
                          <h3>5.0 Support and Maintenance</h3>
                          (5.1) KonaMetrix Inc. has no obligation under this End User License Agreement to provide any support, maintenance, or other services to obsolete products. Licensee may contact KonaMetrix Inc. to determine the availability of support, maintenance and other services, and the fees, terms and conditions applicable thereto.
                          <br/><br/>
                          <h3>6.0 Term and Termination</h3>
                          (6.1) Licensor has the right to terminate your license immediately if you fail to comply with any term of this Agreement.
                          <br/><br/>
                          <h3>7.0 Confidentiality</h3>
                          (7.1) Scope. The term Confidential Information means all trade secrets, know- how, software, hardware and other financial, business or technical information of Licensor or any of its suppliers that is disclosed by or for Licensor in relation to this Agreement, but not including any information Licensee can demonstrate is
                          <br/><br/>
                          (7.2) rightfully furnished to it without restriction by a third party without breach of any obligation to the Licensor, (b) generally available to the public without breach of this Agreement or (c) independently developed by it without reliance on such information. All Software, hardware and Documentation is Confidential Information.
                          <br/><br/>
                          (7.3) Except for the specific rights granted by this Agreement, Licensee shall not possess, use or disclose any Confidential Information without Licensor's prior written consent, and shall use reasonable care to protect the Confidential Information. Licensee shall be responsible for any breach of confidentiality by its employees.
                          <br/><br/>
                          <h3>8.0 Limited Warranty:</h3>
                          (8.1) KonaMetrix Inc. warrants the Product to be free from defects in materials and workmanship properly installed and under normal use for a period of one (1) year from the date of purchase as evidenced by a copy of the receipt. KonaMetrix Inc. entire liability and your exclusive remedy will be replacement of the product returned to KonaMetrix Inc. with a copy of the receipt. KonaMetrix Inc. shall not replace Product damaged by accident, abuse or misapplication. ANY IMPLIED WARRANTIES ON THE PRODUCT, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, ARE LIMITED IN DURATION TO NINETY
                          (90) DAYS FROM THE DATE OF DELIVERY. THIS WARRANTY GIVES YOU SPECIFIC LEGAL RIGHTS, AND YOU MAY ALSO HAVE OTHER RIGHTS WHICH VARY BY JURISDICTION.
                          <br/><br/>
                          <h3>9.0 Disclaimer of Warranty</h3>
                          (9.1) THE PRODUCT AND DOCUMENTATION ARE LICENSED "AS IS," AND KONAMETRIX INC. DISCLAIMS ANY AND ALL OTHER WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR
                          PURPOSE, TO THE EXTENT AUTHORIZED BY LAW. WITHOUT LIMITATION OF THE FOREGOING, KONAMETRIX INC. EXPRESSLY DOES NOT WARRANT THAT THE PRODUCT WILL MEET YOUR REQUIREMENTS OR THAT OPERATION OF THE PRODUCT WILL BE UNINTERRUPTED OR ERROR FREE. YOU ASSUME RESPONSIBILITY FOR SELECTING THE PRODUCT TO ACHIEVE YOUR INTENDED RESULTS, AND FOR THE RESULTS OBTAINED FROM YOUR USE OF THE PRODUCT. YOU SHALL BEAR THE ENTIRE RISK AS TO THE QUALITY AND THE PERFORMANCE OF THE PRODUCT.
                          <br/><br/>
                          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL KONAMETRIX INC. OR ITS SUPPLIERS OR RESELLERS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, INCIDENTAL, PUNITIVE OR SPECIAL DAMAGES WHATSOEVER, WITHOUT REGARD TO CAUSE OR THEORY OF LIABILITY (INCLUDING, WITHOUT LIMITATION, DAMAGES INCURRED FOR LOSS OF BUSINESS PROFITS OR REVENUE, LOSS OF PRIVACY, LOSS OF USE OF ANY COMPUTER OR SOFTWARE INCLUDING THE SOFTWARE, BUSINESS INTERRUPTION, LOSS OF BUSINESS INFORMATION OR OTHER PECUNIARY LOSS) ARISING OUT OF THIS AGREEMENT OR THE PRODUCT PROVIDED HEREUNDER, EVEN IF KONAMETRIX INC. HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATION SHALL APPLY NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.
                          <br/><br/>
                          <h3>10.0 Remedies</h3>
                          (10.1) Upon a request by KonaMetrix Inc., you agree to defend, indemnify, and hold harmless KonaMetrix Inc. from all liabilities, claims, and expenses, including attorney's fees, that arise from your use of the hardware, software or Data Content in a manner not in strict conformance with these Terms of Use.
                          <br/><br/>
                          <h3>12.0 Indemnification</h3>
                          You agree to indemnify, defend, and hold KonaMetrix Inc. and its officers, employees, subsidiaries and affiliates harmless from and against, any losses suffered, incurred, or sustained by You or by third party to the extent resulting from, arising out of, or relating to, any claim or use of the product or software.
                          <br/><br/>
                          <h3>13.0 General Provisions:</h3>
                          (13.1) Entire Agreement.
                          <br/><br/>
                          This Agreement contains the entire agreement and understanding between the parties with regard to the subject matter hereof and supersedes all prior and contemporaneous oral or written agreements and representations.
                          <br/><br/>
                          (13.2) Assignment. You may not assign this Agreement or any of your rights under this Agreement without the prior written consent of Licensor, and any attempted assignment without such consent shall be void.
                          <br/><br/>
                          (13.3) Amendment. You may not amend or modify this EULA without the Licensor's express prior written consent.
                          <br/><br/>
                          (13.4) Notices. All notices required to be sent hereunder will be in writing and will be deemed to have been given when mailed by first class mail to the address shown on the relevant Order Form (if to Licensee) or to Licensor address shown on the relevant Order Form (if to Licensor).
                          <br/><br/>
                          (13.5) Governing Law. This Agreement shall be governed by the laws of the State of California, without reference to conflict of laws principles.
                          <br/><br/>
                          (13.6) Injunctive Relief. You acknowledge and agree that, notwithstanding any other provisions of these Terms of Use, your breach or threatened breach of these Terms of Use shall cause Licensor irreparable damage for which recovery of money damages would be inadequate and that Licensor, therefore, may obtain timely injunctive relief to protect its rights under these Terms of Use in addition to any and all other remedies available at law or in equity.
                          <br/><br/>
                          (13.7) Waiver. The failure of Licensor at any time or times to require performance of any provision of this Agreement shall in no manner affect its right at a later time to enforce the same unless the same is waived in writing.
                          <br/><br/>
                          (13.8) Severability. If any provision of this Agreement is held by a court of competent jurisdiction to be invalid, illegal, or unenforceable, the remainder of this Agreement will remain in full force and effect.
                          <br/><br/>
                          (13.9) Government End Users. The software and documentation are "commercial items" as that term is defined at 48 C.F.R.2.101, consisting of commercial computer software and commercial computer software documentation as such terms are used in 48 C.F.R. 12.212. Consistent with 48 C.F.R. 12.212 and 48
                          C.F.R. 227.7202-1 through 227.7202-4, all U.S. Government end users acquire the software and documentation with only those restricted rights as set forth herein.
                          <br/><br/>
                          (13.1.1) Export Restrictions. You acknowledge that the Software are of U.S. origin. You agree to comply with all applicable U.S. and international laws governing export and reexport of the Software, including the U.S. Export Administration Regulations, as well as end-user, end-use and destination restrictions issued by U.S. and other governments.
                        </div>
                        <br/>
                        <table width="100%" style="font-weight: bold">
                          <tr>
                            <td>Customer is authorized and agrees to accept the terms of this End User Product License Agreement.</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        </div>

        <b-modal id="modal-create-user" title="New User" size="lg" v-model="modal_create_user">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_create_user_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Email:" label-for="input-1">
                    <b-form-input id="input-1" v-model="new_user.email" type="text" required/>
                </b-form-group>
                <b-form-group label="First Name:" label-for="input-2">
                    <b-form-input id="input-2" v-model="new_user.first_name" type="text" required/>
                </b-form-group>
                <b-form-group label="Last Name:" label-for="input-3">
                    <b-form-input id="input-3" v-model="new_user.last_name" type="text" required/>
                </b-form-group>
                <b-form-group label="Password:" label-for="input-4">
                    <b-form-input id="input-4" v-model="new_user.password" type="password" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="create_user"  class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-user" title="Edit User" size="lg" v-model="modal_edit_user">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_edit_user_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Email:" label-for="input-1a">
                    <b-form-input id="input-1a" v-model="updated_user.email" type="text" required/>
                </b-form-group>
                <b-form-group label="First Name:" label-for="input-2a">
                    <b-form-input id="input-2a" v-model="updated_user.first_name" type="text" required/>
                </b-form-group>
                <b-form-group label="Last Name:" label-for="input-3a">
                    <b-form-input id="input-3a" v-model="updated_user.last_name" type="text" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="edit_user"  class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-address" title="Edit Address" size="lg"  v-model="modal_edit_address">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_address_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Address Line 1:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="address[0].line_1" type="text" required/>
                </b-form-group>
                <b-form-group label="Address Line 2:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="address[0].line_2" type="text" required/>
                </b-form-group>
                <b-form-group label="City:" label-for="input-2b">
                    <b-form-input id="input-2b" v-model="address[0].city" type="text" required/>
                </b-form-group>
                <b-form-group label="State:">
                    <b-form-select required v-model="address[0].state" :options="stateOptions" id="3-b"/>
                </b-form-group>
                <b-form-group label="Zip Code:" label-for="input-4b">
                    <b-form-input id="input-4b" v-model="address[0].zip" type="email" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="edit_address" class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

    </div>

</template>

<script>

    import { admin_methods } from '../../networking/account'
    import AccountInfo from '../../widgets/AccountInfo'
    import { stateOptions } from '../../config/address'

    const confirmation_box_config = {
        title: 'Confirm Deletion',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
    }
    
    export default {

        components:{ AccountInfo },
        props:{
            userData:{
                type: Object,
                required: true
            }            
        },

        data(){
            return{
                stateOptions: stateOptions,
                modal_create_user: false,
                modal_edit_user: false,
                modal_edit_address: false,

                nameEdit: false,
                edit_buttons_disabled: false,

                account:{},
                address: [{}],
                address_fields: [{ key:'line_1', label: 'Address 1'}, { key:'line_2', label: 'Address 2'}, { key: 'city'}, { key: 'state'}, { key: 'zip' }],

                users: [],
                user_fields: [{ key: 'email' }, { key: 'first_name' }, { key: 'last_name' }, { key: 'action' }],

                new_user: { email: '', first_name: '', last_name: '', role_code:'CU' },
                updated_user: { email: '', first_name: '', last_name: '' }

            }
        },

        async created(){
            this.set_new_user()
            await this.get_account()
            await this.get_users()
            await this.get_address()
        },

        methods: {

            edit_name(bool){this.nameEdit=bool},
            select_user(user){
                this.updated_user = user
                this.modal_edit_user = !this.modal_edit_user
            },

            toggle_create_user_modal(){
                this.new_user = []
                this.modal_create_user = !this.modal_create_user
            },
            toggle_edit_user_modal(){ this.modal_edit_user = !this.modal_edit_user },
            toggle_address_modal(){ this.modal_edit_address = !this.modal_edit_address },

            async get_account(){
                const admin_generator = admin_methods.get_account(this.userData.accountId)
                const { value: { data }} = await admin_generator.next()
                this.account = data
            },
            async update_account(){
                this.edit_name(false)
                const admin_generator = admin_methods.update_account(this.account)
                const { value: { data }} = await admin_generator.next()
                await this.get_account()
            },

            async get_users(){
                const admin_generator = admin_methods.get_users(this.account.id)
                const { value: { data }} = await admin_generator.next()
                this.users = data
            },
            async create_user(){
                this.modal_create_user = !this.modal_create_user
                this.$emit('showAlert', 'Creating User', 'info')
                const admin_generator = admin_methods.create_user(this.new_user)
                const { value: { data }} = await admin_generator.next()
                await this.get_users()
                this.$emit('showAlert', 'Created User', 'success', 1800)
            },
            async edit_user(){
                this.modal_edit_user = !this.modal_edit_user
                this.$emit('showAlert', 'Updating User', 'info')
                const admin_generator = admin_methods.edit_user(this.updated_user)
                const { value: { data }} = await admin_generator.next()
                await this.get_users()
                this.$emit('showAlert', 'Updated User', 'success', 1800)
            },
            async delete_user(user){
                const admin_generator = admin_methods.delete_user(user)
                const { value: { data }} = await admin_generator.next()
                await this.get_users()
                this.$emit('showAlert', 'Deleted User', 'success', 1800)
            },

            async get_address(){
                const admin_generator = admin_methods.get_address(this.account.id)
                const { value: { data = [] }} = await admin_generator.next()
                if(data.length === 0){
                    const address_generator = admin_methods.create_address({
                        account_id: this.account.id,
                        line_1: ' ', line_2: ' '
                    })
                    const { value: { data: new_address }} = await address_generator.next()
                    this.address = [new_address]
                } else { this.address = data }
            },
            async edit_address(){
                this.modal_edit_address = !this.modal_edit_address
                this.$emit('showAlert', 'Updating Address', 'info')
                const admin_generator = admin_methods.edit_address(this.address[0])
                const { value: { data }} = await admin_generator.next()
                await this.get_address()
                this.$emit('showAlert', 'Updated Address', 'success', 1800)
            },

            set_new_user(){
                this.new_user.account_id = this.userData.accountId
            },

            async request_delete(user){
                const value = await this.$bvModal.msgBoxConfirm(
                    this.$createElement('div',{ domProps:{
                        innerHTML: `<p>Are you sure you want to delete user <b>${user.first_name} ${user.last_name}</b>?</p>`
                    } }),
                    confirmation_box_config
                )
                value ? this.delete_user(user) : null
            }
        }
    }

</script>


<style scoped>

.form-inline{
    width: 680px!important;
}
    

</style>